<!-- 进度条配置 -->
<template>
  <div>
    <el-form-item label="类型">
      <el-radio-group v-model="main.activeOption.type" size="small">
        <el-radio label="line">线形</el-radio>
        <el-radio label="circle">环形</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="点击事件">
      <el-input v-model="main.activeOption.clickHandler">
        <template #suffix>
          <el-button @click="openCode" size="small" :icon="Edit"></el-button>
        </template>
      </el-input>
    </el-form-item>
    <el-form-item label="环形大小" v-if="main.activeOption.type == 'circle'">
      <el-input-number
          v-model="main.activeOption.circleSize"
          size="small"
          controls-position="right"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="条纹" v-if="main.activeOption.type == 'line'">
      <el-switch v-model="main.activeOption.striped" size="small"></el-switch>
    </el-form-item>
    <el-form-item label="进度条宽度">
      <el-input-number
          v-model="main.activeOption.strokeWidth"
          :max="50"
          size="small"
          controls-position="right"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="背景颜色">
      <el-color-picker
          v-model="main.activeOption.backgroundColor"
      ></el-color-picker>
    </el-form-item>
    <el-form-item label="未达标颜色">
      <el-color-picker
          v-model="main.activeOption.unachievedColor"
      ></el-color-picker>
    </el-form-item>
    <el-form-item label="未达标数值">
      <el-input-number
          v-model="main.activeOption.unachievedValue"
          :min="0"
          size="small"
          controls-position="right"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="达标颜色">
      <el-color-picker
          v-model="main.activeOption.achievedColor"
      ></el-color-picker>
    </el-form-item>
    <el-form-item label="总数值">
      <el-input-number
          v-model="main.activeOption.totalValue"
          :min="0"
          size="small"
          controls-position="right"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="总数值函数">
      <el-input v-model="main.activeOption.totalValueFunc"></el-input>
    </el-form-item>
    <el-form-item label="字体大小">
      <el-input-number
          v-model="main.activeOption.fontSize"
          :max="200"
          size="small"
          controls-position="right"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="字体颜色">
      <el-color-picker v-model="main.activeOption.color"></el-color-picker>
    </el-form-item>
    <el-form-item label="文字粗细">
      <el-select v-model="main.activeOption.fontWeight" size="small">
        <el-option
            v-for="item in dicOption.fontWeight"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="文字位置" v-if="main.activeOption.type == 'line'">
      <el-switch
          v-model="main.activeOption.suffixPosition"
          active-text="左侧"
          inactive-text="上侧"
          size="small"
      ></el-switch>
    </el-form-item>
    <el-form-item label="后缀展示内容" v-if="!main.activeOption.suffixPosition">
      <el-switch
          v-model="main.activeOption.showPercentage"
          size="small"
          active-text="百分比"
          inactive-text="数值"
      ></el-switch>
    </el-form-item>
    <el-form-item label="后缀单位" v-if="!main.activeOption.suffixPosition">
      <el-input v-model="main.activeOption.unit" size="small"></el-input>
    </el-form-item>
    <el-form-item label="前缀字体大小" v-if="main.activeOption.type == 'line'">
      <el-input-number
          v-model="main.activeOption.suffixFontSize"
          :max="200"
          size="small"
          controls-position="right"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="前缀字体颜色" v-if="main.activeOption.type == 'line'">
      <el-color-picker
          v-model="main.activeOption.suffixColor"
      ></el-color-picker>
    </el-form-item>
    <el-form-item label="前缀文字粗细" v-if="main.activeOption.type == 'line'">
      <el-select v-model="main.activeOption.suffixFontWeight" size="small">
        <el-option
            v-for="item in dicOption.fontWeight"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <codeedit
        @submit="closeCode"
        v-if="code.box"
        :title="code.title"
        :type="code.type"
        v-model="code.obj"
        v-model:visible="code.box"
    ></codeedit>
  </div>
</template>

<script>
import {singleColorOption, dicOption} from "@/option/config";
import {deepClone} from "@/echart/util";
import {Edit} from "@element-plus/icons-vue";
import {reactive} from "vue";
import codeedit from "@/page/group/code.vue";

export default {
  name: "progress",
  components: {codeedit},
  computed: {
    Edit() {
      return Edit
    }
  },
  data() {
    return {
      dicOption: dicOption,
      colorOption: singleColorOption,
      code: {
        title: "点击事件",
        box: false,
        type: "resHandler",
        obj: "",
      }
    };
  },
  inject: ["main"],
  methods: {
    closeCode(v) {
      this.main.activeOption.clickHandler = v
    },
    openCode() {
      this.code.obj = this.main.activeOption.clickHandler
      this.code.type = 'clickHandler'
      this.code.title = '点击事件'
      this.code.box = true;
    },
    rowSave(row, done) {
      if (!this.main.activeOption.achievedColor) {
        this.main.activeOption.achievedColor = [];
      }
      this.main.activeOption.achievedColor.push(deepClone(row));
      done();
    },
    rowDel(row, index) {
      this.main.activeOption.achievedColor.splice(index, 1);
    },
    rowUpdate(row, index, done) {
      this.main.activeOption.achievedColor.splice(index, 1, deepClone(row));
      done();
    },
  },
};
</script>

<style></style>
